import { render, staticRenderFns } from "./OnGoingSchemes.vue?vue&type=template&id=476b0388&scoped=true"
import script from "./OnGoingSchemes.vue?vue&type=script&lang=js"
export * from "./OnGoingSchemes.vue?vue&type=script&lang=js"
import style0 from "./OnGoingSchemes.vue?vue&type=style&index=0&id=476b0388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b0388",
  null
  
)

export default component.exports